import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    subscription_from: yup.string().required('Поле обязательно'),
    subscription_to: yup.string().required('Поле обязательно'),
});
